import { ClickAwayListener } from "@cirrus/ui-kit"
import Button from "@cirrus/legacy/app-components/buttons/button/index.jsx"
import classNames from "classnames"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import styles from "./content.less"

class Content extends C {
  static propTypes = {
    children: PropTypes.node,
    close: PropTypes.func,
    containerWidth: PropTypes.number,
  }

  isDescendant(parent, child) {
    let node = child

    if (this.closeIcon === child) {
      return true
    }

    while (node !== null) {
      if (node === parent) {
        return true
      }

      node = node.parentNode
    }

    return false
  }

  close = () => {
    this.props.close && this.props.close()
  }

  setContainerRef = (containerReference) => {
    this.containerRef = containerReference
  }

  render() {
    const { children, containerClass, containerWidth } = this.props

    return (
      <ClickAwayListener onClickAway={this.close}>
        <div
          ref={this.setContainerRef}
          className={classNames(styles.container, containerClass)}
          style={containerWidth ? { width: `${containerWidth} px` } : null}>
          <Button
            className={classNames(styles.closeButton, "icon", "icon-cross")}
            getButton={(button) => (this.closeIcon = button)}
            tabIndex={1001}
            onClick={this.close}
          />
          {children}
        </div>
      </ClickAwayListener>
    )
  }
}

export default Content
